import {Component, Output, Input, EventEmitter, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { Round } from 'src/app/shared/model/poll.model';

@Component({
  selector: 'app-vote-confirmation-popup',
  templateUrl: 'vote-confirmation-popup.component.html',
  styleUrls: ['./vote-confirmation-popup.component.less', '../../shared/common.less'],
})
export class VoteConfirmationPopupComponent implements OnChanges {
  @Input() isMobile: boolean = false;
  @Input() hash: string = '8bde5ad38ef8dc65dfb663cd216c878c68bbadac0b712c6ecba73cb3e4783eeb';
  @Input() rounds: Array<Round>;
  @Input() round: number = -1;
  @Input() votedStatuses: boolean[] = [];
  @Output() voteConfirmation = new EventEmitter<number>();
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  title = '';
  nextElectionTitle = '';

  confirmVote(confirm: boolean) {
    if (confirm) {
      console.log("confirm vote and go to next election");
      const nextIndex = this.votedStatuses.findIndex(r => r === false);
      if (nextIndex > -1 && this.rounds.length > nextIndex) {
        const nextRound = this.rounds[nextIndex].round;
        this.voteConfirmation.emit(nextIndex);
      } else { this.voteConfirmation.emit(-1); }
    } else {
      this.voteConfirmation.emit(-1);
    }
  }

  clicAction($event) {
    if (
      $event.target.className === 'div-arriere-plan-action' ||
      $event.target.className === 'div-global-action'
    ) {
      this.confirmVote(false);
    }
  }

  cancelDetails(value) {
    this.endDetailsPopup.emit(value);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.rounds.length > 0 && this.round != null) {
      const selRound = this.rounds.filter(r => r.round === this.round);
      if (selRound.length > 0) {
        this.title = selRound[0].title;
      }
    }
    if (changes.votedStatuses && this.rounds.length > 1) {
      const selRoundIdx = this.rounds.findIndex(r => r.round === this.round);
      const nextIndex = this.votedStatuses.findIndex(r => r === false);
      if (nextIndex !== -1 && selRoundIdx !== -1) {
        if (this.rounds.length > nextIndex && this.votedStatuses.length > selRoundIdx) {
          if (this.votedStatuses[selRoundIdx] === true) {
            this.nextElectionTitle = this.rounds[nextIndex].title;
          }
        }
      } else {
        this.nextElectionTitle = '';
      }
    }
  }
}
